import { createLogger } from "@eventstore-ui/utils";
export const logger = createLogger('@eventstore-ui/components', 'radial-gradient( circle farthest-corner at 10% 20%,  rgba(0,95,104,1) 0%, rgba(15,156,168,1) 90% )');
//# sourceMappingURL=logger.js.map
